import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { emptySeason, Season } from "../../../../interfaces/season";
import { useEffect, useState } from "react";
import { deleteSeason, getSeasonsSingle } from "../../../../services/season";
import { Trans } from "react-i18next";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminSeasonDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function AdminSeasonDelete(props: AdminSeasonDeleteProps) {
    const [season, setSeason] = useState<Season>(emptySeason);

    const handleDelete = () => {
        deleteSeason(props.id)
            .then(response => {
                if (response.data == 0) {
                    alert(t("Season cannot be deleted. There is data related."));
                } else {
                    props.onDelete(props.id);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getSeasonsSingle(props.id)
            .then(response => {
                setSeason(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="admin-season-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_season") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { season.id == 0 && 
                    <LoadingSpinner />
                }
                { season.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_season_message"
                                values={{
                                    season_name: season.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}